<template>
  <div>
    <div class="mb-3 text-right">
      <base-button modal="#investorAllocationModal" secondary>
        Allocate Shares
      </base-button>
      <base-button class="ml-2" modal="#investorRemoveSharesModal" secondary>
        Remove Shares
      </base-button>
      <base-button class="mx-2" modal="#investorRefinanceModal" secondary>
        Change Re-Financing
      </base-button>
      <base-button modal="#shareTransferModal" secondary>
        Transfer Shares
      </base-button>
    </div>
    <template v-if="shares.length">
      <base-card v-for="(share, key) in shares" :key="key" tabled>
        <base-table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Funding</th>
              <th>Shares</th>
              <th>Value</th>
              <th>Accrued</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ share._id }}</td>
              <td>{{ share.funding.name }}</td>
              <td>{{ share.totalShares }}</td>
              <td>{{ $formatting.toCurrency(share.totalValue) }}</td>
              <td>{{ $formatting.toCurrency(share.totalAccrued) }}</td>
            </tr>
          </tbody>
        </base-table>
        <base-table>
          <thead>
            <tr>
              <th>Buyer</th>
              <th>Seller</th>
              <th>Accrued Days</th>
              <th>Accrued Amount</th>
              <th>Total Shares</th>
              <th>Total Value</th>
              <th>Active</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(log, k) in share.audit" :key="k">
              <td>
                {{ log.buyer.profile.firstName }} {{ log.buyer.profile.lastName }}
                <br>
                {{ log.buyer.email }}
              </td>
              <td>
                <template v-if="log.seller">
                  {{ log.seller.profile.firstName }} {{ log.seller.profile.lastName }}
                  <br>
                  {{ log.seller.email }}
                </template>
              </td>
              <td>{{ log.totalDaysAccruedFor }}</td>
              <td>{{ $formatting.toCurrency(log.totalAccrued) }}</td>
              <td>{{ log.totalShares }}</td>
              <td>{{ $formatting.toCurrency(log.totalCost) }}</td>
              <td>{{ log.active ? 'Yes' : 'No' }}</td>
            </tr>
          </tbody>
        </base-table>
      </base-card>
      <template v-if="pages > 1">
        <base-pagination :current="page" :total="pages" @go="request" />
      </template>
    </template>
    <investment-unit-refinance />
    <investment-unit-transfer />
    <investor-allocation @close="$emit('refresh')" />
    <investor-remove-shares />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import InvestmentUnitRefinance from '@/components/InvestmentUnitRefinance.vue'
import InvestmentUnitTransfer from '@/components/InvestmentUnitTransfer.vue'
import InvestorAllocation from '@/components/InvestorAllocation.vue'
import InvestorRemoveShares from '@/components/InvestorRemoveShares.vue'

export default {
  name: 'InvestmentShares',

  components: {
    InvestmentUnitRefinance,
    InvestmentUnitTransfer,
    InvestorAllocation,
    InvestorRemoveShares
  },

  data: () => ({
    page: 1
  }),

  created () {
    this.request()
  },

  computed: {
    ...mapState({
      investment: store => store.core.investments.entity,
      pages: store => store.core.shares.totalPages,
      shares: store => store.core.shares.rows
    })
  },

  methods: {
    request (page) {
      if (page) this.page = page

      this.getShares({
        page: this.page,
        query: {
          investment: this.investment._id
        }
      })
    },

    ...mapActions({
      getShares: 'core/shares/list'
    })
  }
}
</script>
